

// import React, { useEffect, useState } from "react";
// import Plot from "react-plotly.js";
// import useHttp from "../../../hook/use-http";
// import { API_URL_MAIN } from "../../../constants/driveglobalfilterinitalstates_bus";

// const COLUMN_MAPPING = {
//     IR: "Min_IR_Ohmic_Min",
//     SOH: "Min_SOH_Min",
//     Capacity_Ah: "Min_Capacity_Ah_Min",
//     Power_Cha: "Max_Power_Cha_Max",
//     Power_Operation: "Max_Power_Operation_Max",
//     max_Temp: "Max_Temperature_Max",
//     min_Temp: "Min_Temperature_Min",
// };

// const Test2 = ({ filterdata }) => {
//     const { isLoading, error, sendReq: fetchData } = useHttp();
//     const [packType, setPackType] = useState("A");
//     const [packData, setPackData] = useState([]);
//     const [apiType, setApiType] = useState("SOH");
//     const [stateOfCharge, setStateOfCharge] = useState("Maximum");

//     useEffect(() => {
//         const columnName = COLUMN_MAPPING[apiType];
//         fetchData(
//             {
//                 url: `${API_URL_MAIN}battery_digital_twin/Vehicle_level_plots_${apiType}`,
//                 body: { packType, filterdata },
//             },
//             (data) => {
//                 if (data) {
//                     const formattedData = data.map((item) => ({
//                         x: item.Pack_Cycle,
//                         y: item[columnName] || 0,
//                     }));
//                     setPackData(formattedData);
//                 }
//             }
//         );
//     }, [packType, apiType, filterdata]);

//     return (
//         <div className="p-6 bg-gray-100 min-h-screen flex justify-center items-center">
//             <div className="bg-white rounded-xl shadow-md w-full max-w-[1200px] grid grid-cols-12 gap-4">
//                 {/* Left Sidebar for Controls */}
//                 <div className="col-span-3 p-4 border-r">
//                     <div className="mb-4">
//                         <div className="flex items-center space-x-2 mb-2">
//                             <label className="font-semibold">Select Pack:</label>
//                             {["A", "B", "C", "D"].map((pack) => (
//                                 <label key={pack} className="flex items-center space-x-1">
//                                     <input
//                                         type="radio"
//                                         value={pack}
//                                         checked={packType === pack}
//                                         onChange={() => setPackType(pack)}
//                                         className="form-radio h-4 w-4 text-blue-600"
//                                     />
//                                     <span>{pack}</span>
//                                 </label>
//                             ))}
//                         </div>
//                     </div>
                   


//                     <div className="mb-4">
//                         <label className="block font-semibold mb-2">State of health:</label>
//                         <select
//                             value={apiType}
//                             onChange={(e) => setApiType(e.target.value)}
//                             className="w-full border border-gray-300 rounded-lg px-4 py-2"
//                         >
//                             {Object.keys(COLUMN_MAPPING).map((key) => (
//                                 <option key={key} value={key}>{key}</option>
//                             ))}
//                         </select>
//                     </div>

//                 </div>

//                 {/* Main Chart Area */}
//                 <div className="col-span-9 p-4">
//                     {isLoading && <p className="text-center text-blue-500">Loading data...</p>}
//                     {error && <p className="text-center text-red-500">Error: {error}</p>}
//                     {packData.length > 0 && (
//                         <Plot
//                             data={[
//                                 {
//                                     x: packData.map((d) => d.x),
//                                     y: packData.map((d) => d.y),
//                                     mode: "markers",
//                                     type: "scatter",
//                                     marker: { color: "red", size: 6 },
//                                     name: `Observed ${apiType}`,
//                                 },
//                                 {
//                                     x: packData.map((d) => d.x),
//                                     y: packData.map((d) => d.y),
//                                     type: "scatter",
//                                     mode: "lines",
//                                     line: { color: "blue", width: 3 },
//                                     name: "Trend Line",
//                                 }
//                             ]}
//                             layout={{
//                                 autosize: true,
//                                 margin: { l: 50, r: 50, b: 50, t: 50 },
//                                 xaxis: { title: "Cycle ID" },
//                                 yaxis: { title: `${apiType} (%)` },
//                                 showlegend: true,
//                                 legend: { x: 1, y: 1 },
//                             }}
//                             style={{ width: "100%", height: "350px" }} // Further reduced height
//                             config={{ displayModeBar: false }}
//                         />
//                     )}
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default Test2;

import React, { useEffect, useState } from "react";
import Plot from "react-plotly.js";
import useHttp from "../../../hook/use-http";
import { API_URL_MAIN } from "../../../constants/driveglobalfilterinitalstates_bus";

const COLUMN_MAPPING = {
    IR: "Min_IR_Ohmic_Min",
    SOH: "Min_SOH_Min",
    Capacity_Ah: "Min_Capacity_Ah_Min",
    Power_Cha: "Max_Power_Cha_Max",
    Power_Operation: "Max_Power_Operation_Max",
    max_Temp: "Max_Temperature_Max",
    min_Temp: "Min_Temperature_Min",
};

const Test2 = ({ filterdata }) => {
    const { isLoading, error, sendReq: fetchData } = useHttp();
    const [packType, setPackType] = useState("B");
    const [packData, setPackData] = useState([]);
    const [apiType, setApiType] = useState("SOH");
    const [stateOfCharge, setStateOfCharge] = useState("Maximum");

    useEffect(() => {
        const columnName = COLUMN_MAPPING[apiType];
        fetchData(
            {
                url: `${API_URL_MAIN}battery_digital_twin/Vehicle_level_plots_${apiType}`,
                body: { packType, filterdata },
            },
            (data) => {
                if (data) {
                    const formattedData = data.map((item) => ({
                        x: item.Pack_Cycle,
                        y: item[columnName] || 0,
                    }));
                    setPackData(formattedData);
                }
            }
        );
    }, [packType, apiType, filterdata]);

    return (
        <div className="p-6 bg-gray-100 min-h-screen flex justify-center items-center">
            <div className="bg-white rounded-xl shadow-md w-full max-w-[1200px] grid grid-cols-12 gap-4">
                {/* Left Sidebar for Controls */}
                <div className="col-span-3 p-4 border-r">
                    <div className="mb-6">
                        <div className="flex items-center mb-2">
                           
                            <div className="flex space-x-5">
                                {["A", "B", "C", "D"].map((pack) => (
                                    <label key={pack} className="inline-flex items-center">
                                        <input
                                            type="radio"
                                            value={pack}
                                            checked={packType === pack}
                                            onChange={() => setPackType(pack)}
                                            className="form-radio h-4 w-4 text-blue-600 mr-1"
                                        />
                                        <span>Pack {pack}</span>
                                    </label>
                                ))}
                            </div>
                        </div>
                    </div>
                   
                    <div className="mb-4">
                        <label className="block font-semibold mb-2">State of health:</label>
                        <select
                            value={apiType}
                            onChange={(e) => setApiType(e.target.value)}
                            className="w-full border border-gray-300 rounded-lg px-4 py-2"
                        >
                            {Object.keys(COLUMN_MAPPING).map((key) => (
                                <option key={key} value={key}>{key}</option>
                            ))}
                        </select>
                    </div>
                </div>

                {/* Main Chart Area */}
                <div className="col-span-9 p-4">
                    {isLoading && <p className="text-center text-blue-500">Loading data...</p>}
                    {error && <p className="text-center text-red-500">Error: {error}</p>}
                    {packData.length > 0 && (
                        <Plot
                            data={[
                                {
                                    x: packData.map((d) => d.x),
                                    y: packData.map((d) => d.y),
                                    mode: "markers",
                                    type: "scatter",
                                    marker: { color: "red", size: 6 },
                                    name: `Observed ${apiType}`,
                                },
                                {
                                    x: packData.map((d) => d.x),
                                    y: packData.map((d) => d.y),
                                    type: "scatter",
                                    mode: "lines",
                                    line: { color: "blue", width: 3 },
                                    name: "Trend Line",
                                }
                            ]}
                            layout={{
                                autosize: true,
                                margin: { l: 50, r: 50, b: 50, t: 50 },
                                xaxis: { title: "Cycle ID" },
                                yaxis: { title: `${apiType} (%)` },
                                showlegend: true,
                                legend: { x: 1, y: 1 },
                            }}
                            style={{ width: "100%", height: "350px" }}
                            config={{ displayModeBar: false }}
                        />
                    )}
                </div>
            </div>
        </div>
    );
};

export default Test2;